import MobileDetect from 'mobile-detect';

/**
 * Detects device/browser/os on mobile devices and adds them to document element
 * - You can use them as css selectors
 * - Or use this class in other scripts for detection
 */
export default function DetectDevice() {
    return {
        agent: new MobileDetect(window.navigator.userAgent),

        init: function() {
            const $this = this;
            const properties = [
                this.agent.os(),
                this.agent.userAgent(),
                this.agent.mobile()
            ];
            const root = document.documentElement;
            const agent = this.agent;

            // add browser type(s)
            // because IE Edge is schizophrenic, test it first, it's not chrome or whatever

            if (
                agent.ua.indexOf('Trident') != -1 ||
                agent.ua.indexOf('Edge') != -1
            ) {
                this.addClass(root, 'ie');
            } else if (agent.ua.indexOf('MSIE') != -1) {
                this.addClass(root, 'old-ie');
            } else if (agent.ua.indexOf('Firefox') != -1) {
                this.addClass(root, 'firefox');
            } else if (agent.ua.indexOf('Chrome') != -1) {
                this.addClass(root, 'chrome');
            }

            // add device specific properties to documentElement
            properties.forEach(function(value) {
                if (value === 'iOS') {
                    $this.addClass(
                        root,
                        'ios-' + parseFloat(agent.versionStr('iOS'))
                    );
                }
                if (value != null) {
                    $this.addClass(
                        root,
                        typeof value === 'string' ? value.toLowerCase() : value
                    );
                }
            });

            // mobile/desktop identifier
            const deviceType =
                this.agent.mobile() != null ? 'is-mobile' : 'is-desktop';
            this.addClass(root, deviceType);

            // passive event listeners
            const passiveEventListeners = this.supportsPassive()
                ? 'supports-passive-events'
                : '';
            this.addClass(root, passiveEventListeners);
        },

        /**
         * Test passive event listeners
         * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
         */
        supportsPassive: function() {
            let passive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    get: function() {
                        return (passive = true);
                    }
                });
                window.addEventListener('testPassive', null, opts);
                window.removeEventListener('testPassive', null, opts);
            } catch (e) {
                return;
            }

            return passive;
        },

        addClass: function(el, value) {
            if (el.classList) {
                el.classList.add(value);
            } else if (el.classList.contains(value)) {
                const classListValue = el.getAttribute('class')
                    ? el.getAttribute('class') + ' ' + value
                    : value;
                el.setAttribute('class', classListValue);
            }
        }
    };
}
